<div class="px-2">
  <div class="flex gap-2 align-items-center justify-content-center pt-6 text-lg">
    <i class="pi pi-face-smile text-xl"></i>
    <span>{{'PLAYER_PROFILE_THANKS_FOR_PURCHASE' | translate}}</span>
  </div>
  <div class="pt-6 flex align-items-center">
    <div class="flex-1"></div>
    <p-button icon="pi pi-home" styleClass="w-full md:w-12rem p-button-secondary"
              routerLink="/frontend/player/profile/dashboard"
              [label]="'DASHBOARD' | translate"/>
    <div class="flex-1"></div>
    <p-button icon="pi pi-wallet" styleClass="w-full md:w-12rem p-button-secondary"
              routerLink="/frontend/player/profile/account/payments"
              [label]="'PAYMENTS' | translate"/>
    <div class="flex-1"></div>
  </div>
</div>
